import React,{Component} from 'react';
import { NavBar,InputItem,Toast} from 'antd-mobile';
import { salesgetCode,salesRegister} from "../../../service/memberService";
import './style.less'
import connect from "react-redux/es/connect/connect";
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InviteAdd extends Component{
    constructor(props) {
        super(props);
        this.state={
            mobile:"",
            code:"",
            getCodeText:"获取验证码",
            getCodeDisabled: false,
            modal:false,
        }
    }
    componentDidMount() {}
    invite(){
        if(this.state.mobile == ""){
            Toast.info("请输入手机号码！");
            return
        }
        // if(this.state.code == ""){
        //     Toast.info("请输入验证码！");
        //     return
        // }

        let index = window.location.href.lastIndexOf("?");
        // console.log(window.location.href.substring(0,index).split('id=')[1]);
        // console.log(window.location.href.split('id=')[1]);
        //如果调用成功显示modal
        Toast.loading("正在加载",0);
        let params = {
            phone:this.state.mobile.replace(/\s/ig, ''),
            // smsCode:this.state.code,
            referrerId:window.location.href.substring(0,index).split('id=')[1] == undefined ? window.location.href.split('id=')[1] : window.location.href.substring(0,index).split('id=')[1],
        };
        salesRegister(params).then((res)=>{
            Toast.hide();
            if(res.data.code == "0000"){
                if(window.location.href.split('salesmanType=')[1] == 0){
                    Toast.info("注册成功！",2,()=> window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1ODc5NDgzNw==&scene=124#wechat_redirect')
                }else  if(window.location.href.split('salesmanType=')[1] == 1){
                    Toast.info("注册成功！",2,()=> window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU1Nzk1MzEzOQ==&scene=124#wechat_redirect')
                }else  if(window.location.href.split('salesmanType=')[1] == 2){
                    Toast.info("注册成功！",2,()=> window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MTUzODYyNw==&scene=124#wechat_redirect')
                }
            }else{
                Toast.info(res.data.msg,2)
            }
            // 成功跳转到民途公众号首页
            // Toast.info("邀请成功！",2,()=> window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1ODc5NDgzNw==&scene=110#wechat_redirect')
        })
    }
    // 获取验证码
    getCode(type){
        if (phoneReg.test(this.state.mobile.replace(/\s/ig, ''))) {
            this.setState({getCodeDisabled: true,});
            let params = {
                source:2,
                // token:this.props.userInfo.token,
                // data:{
                    phone: this.state.mobile.replace(/\s/ig, ''),
                // },
            };
            type(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setDownTime(60);
                } else {
                    this.setState({getCodeDisabled: false,});
                    Toast.info(res.data.msg,3)
                }
            })
        } else {
            Toast.fail('请输入正确的手机号', 2);
        }
    };

    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeText: time + 's后重新获取'});
            } else {
                this.setState({getCodeText: '获取验证码'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    render(){
        return(
            <div className="friendScreen">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >新用户注册</NavBar>
                    <div className="con">
                        <div className="inp">
                            <InputItem
                                className="phone"
                                clear
                                placeholder="请输入手机号码"
                                type="phone"
                                onChange={(v)=>this.setState({mobile:v})}
                            >
                            </InputItem>
                            {/*<InputItem
                                className="code"
                                type="number"
                                maxLength={6}
                                placeholder="请输入验证码"
                                value={this.state.code}
                                onChange={v => this.setState({code:v})}
                                onBlur={v => window.scroll(0,0)}
                                extra={
                                    <button
                                        style={this.state.getCodeDisabled ? {color:"#9A9B9B"}:null}
                                        disabled={this.state.getCodeDisabled}
                                        onClick={()=>this.getCode(salesgetCode)}
                                    >{this.state.getCodeText}</button>
                                }
                            >
                            </InputItem>*/}
                            <div className="btn"  onClick={()=>this.invite()}></div>
                        </div>

                    </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/InviteAdd/index.js